<template>
  <div>
    <li class="nav-item">
        <a class="nav-link" href="javascript:void(0);" @click="checkDelete">
            <i class="ti-trash"></i>Xoá tài khoản
        </a>
    </li>
  </div>
</template>

<script>
export default {
  props: {
      website: {
        Type: Object,
        data() {
          return {}
        }
      }
  },
    methods: {
    checkDelete() {
      this.$swal.fire({
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Huỷ",
            html: `
              <h3 style="color: red;"><b>Xoá tài khoản</b></h3>
              <p>Bằng việc xoá tài khoản, mọi dữ liệu người dùng bao gồm : Tài khoản, mật khẩu, email, số điện thoại, họ tên, dữ liệu cá nhân... sẽ được xoá vĩnh viễn khỏi trang web ngay lập tức. Quý khách không thể khôi phục lại tài khoản của mình sau khi xoá.</p>
            `,
        }
      ).then((result) => {
          if (result.isConfirmed) {
            this.acceptDelete();
          }
      });
    },

    async acceptDelete() {
      try {
        let uri = this.route('fe_user_delete', {domain: this.website.domain});
        const response = await this.Request.post(uri, {});

        if (response.status == false) {
            this.$swal.fire({
              icon: 'error',
              title: 'Lỗi',
              html: response.data.msg,
            }
          );
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
}
</script>

<style>

</style>
